








































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
@Component({
  components: {}
})
export default class KuaiDiNiaoApiSetting extends AbpBase {
  KuaiDiNiaoApiConfig = {
    BusinessId: null,
    AppKey: null
  }

  ruleKuaiDiNiaoApiConfig = {
    BusinessId: [
      { required: true, message: '请输入商户号ID', trigger: 'blur' }
    ],
    AppKey: [{ required: true, message: '请输入APP KEY', trigger: 'blur' }]
  }

  created() {
    this.getConfig('KuaiDiNiaoApiConfig')
  }

  /**
   * 获取设置
   */
  getConfig(key) {
    MallConfig.getMallConfig(key).then(res => {
      if (res.data) {
        this[key] = res.data
      }
    })
  }

  /**
   * 快递鸟设置
   */
  submit() {
    let vm = this
    let KuaiDiNiaoApiConfig: any = vm.$refs.KuaiDiNiaoApiConfig
    KuaiDiNiaoApiConfig.validate(valid => {
      if (valid) {
        MallConfig.updateMallConfig(
          'KuaiDiNiaoApiConfig',
          '快递鸟设置',
          vm.KuaiDiNiaoApiConfig
        ).then(res => {
          vm.$Notice.success({
            desc: '提交成功'
          })
          vm.getConfig('KuaiDiNiaoApiConfig')
        })
      }
    })
  }
}
